/** @jsx jsx */
import { useState } from 'react';
import { jsx, Text } from 'theme-ui';
import ChevronRightIcon from './icon/chevron-right';
import ChevronDownIcon from './icon/chevron-down';
import PortableText from './portableText';

export default ({ className, title, description }) => {
  const [open, setOpen] = useState(false);
  const Icon = open ? ChevronDownIcon : ChevronRightIcon;
  return (
    <div
      className={className}
      sx={{
        pt: [12, 14],
        pb: [14, 16],
        px: [16, 18],
        fontFamily: 'recipeBody',
        fontSize: [16, 18],
        lineHeight: ['1.625em', '1.666em'],
      }}
    >
      <div
        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        onClick={() => setOpen(!open)}
      >
        <p
          sx={{
            flexGrow: 1,
            fontWeight: open ? 'medium' : 'normal',
          }}
        >
          {title}
        </p>
        <Icon />
      </div>
      {open && (
        <PortableText
          blocks={description}
          sx={{
            mt: [24, 26],
            mb: [10, 12],
            'p + p': { mt: [24, 26] },
          }}
        />
      )}
    </div>
  );
};
